<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">{{ 'followUps.modal.setAssigneeTitle' | translate }}</p>
    <i class="fa-light fa-xmark ms-auto cursor-pointer" (click)="close()"></i>
  </div>
  <div class="modal-body">
    <app-select
      [formControl]="assigneeFormControl"
      [placeholder]="'followUps.modal.placeholders.selectAssignee' | translate"
      data-cy="follow-ups-select-assignee"
    >
      @for (assignee of users; track assignee.id) {
        <app-select-option [value]="assignee.id" [label]="assignee.name" />
      }
    </app-select>
  </div>
  <div class="modal-footer">
    <button
      ngbAutoFocus
      class="btn btn-primary"
      [disabled]="assigneeFormControl.invalid || loading()"
      (click)="submit()"
    >
      @if (loading()) {
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
      } @else {
        {{ 'followUps.modal.buttons.assign' | translate }}
      }
    </button>
  </div>
</div>
